/* eslint-disable @typescript-eslint/naming-convention */

export enum Compass {
  NW,
  N,
  NE,
  E,
  SE,
  S,
  SW,
  W
}
